.text {
    size: 1rem;
}

.chipContainer {
    flex-wrap: wrap;
}

.chip {
    padding: 8px 8px 8px 8px;
    font-size: var(--mantine-font-size-sm);
    background-color: var(--mantine-color-dark-5);
    border: 1px solid var(--mantine-color-dark-3);

    &:hover {
        background-color: var(--mantine-color-dark-4);
    }

    &[data-checked="true"] {
        background-color: var(--mantine-color-success-5);
        color: var(--mantine-color-dark-9);
    }

    &[data-disabled="true"] {
        background-color: var(--mantine-color-dark-4);
        color: var(--mantine-color-dark-1);
    }
}

.chipButton {
    border: 1px solid var(--mantine-color-dark-3);
    font-size: var(--mantine-font-size-sm);
}

.showLessButton {
    border: 1px solid var(--mantine-color-dark-3);
    font-size: var(--mantine-font-size-sm);
    padding-top: 8px;
}
